// extracted by mini-css-extract-plugin
module.exports = {"searchDiv":"videos_searchDiv__3134a","scrollDiv":"videos_scrollDiv__JTERX"};